const dataQualityStyles = {
  pageContent: {
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,             
    overflow: 'auto',
  },

  innerCardContainer: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: '1fr 1fr',
    gap: 2,            
    minHeight: 0,
  },
};

export default dataQualityStyles;
